export const favoriteCompany = {
    favoriteCompanyList: 'Favorite companies saved for "{{theme}}"'
}
